<template lang="html">
  <boxwrap class="user--inner">
    <toolbar></toolbar>
    <boxwrap-contents>

    </boxwrap-contents>
  </boxwrap>
</template>

<script>
export default {
  name: 'user-registration'
}
</script>

<style lang="css" scoped>
</style>
